<p-toast></p-toast>
<p-confirmDialog
  rejectButtonStyleClass="p-button-outlined"
></p-confirmDialog>
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" *ngIf="isScreenAccessible else screenNotAccessible" style="overflow: auto;">
  <div class="card">
    <div class="flex flex-column card-container">
      <div class="mb-1">
        <p-button appPreventDoubleClick *ngIf="documentLookUpData?.isAddButtonVisible"
          label="Add Document"
          (debounceClick)="addDocument()"
          id="addDocumentButton"
          class="add-document-button"
          icon="fa fa-plus"
          iconPos="left"
        ></p-button>
          <button
            *ngIf="documentLookUpData?.isBulkUserReplacementButtonVisible && librarySearch && (librarySearch.selectAllActive || librarySearch.selectedDocumentIds.size > 0)"
            appPreventDoubleClick
            pButton
            pRipple
            icon="fa fa-people-arrows"
            iconPos="left"
            class="p-button-outlined btnBlueColored bulkUserReplacementButton"
            label="Bulk User Replacement"
            id="bulkUserReplacement"
            (debounceClick)="bulkUserReplacement()"
          ></button>
        <app-document-slider *ngIf="isDocumentSliderOpen"
          [isDocumentSliderOpen]="isDocumentSliderOpen"
          (isDocumentSliderActive)="closeDocumentSlider($event)"
        ></app-document-slider>
        <app-document-library-search #librarySearch
          [panelListScreen]="documentLibraryScreen"
          [enableToaster]="enableToaster"
        ></app-document-library-search>

        <app-document-bulk-user-replacement 
          *ngIf="documentLookUpData?.isBulkUserReplacementButtonVisible && librarySearch && (librarySearch.selectAllActive || librarySearch.selectedDocumentIds.size > 0)"
          [isBulkUserReplacementSliderOpen]="isBulkSliderOpen"
          [currentFilters]="librarySearch && librarySearch.currentFilters || null"
          [currentSort]="librarySearch && librarySearch.currentSort || null"
          [currentPagination]="librarySearch && librarySearch.currentPagination || null"
          [primarySearchText]="librarySearch && librarySearch.primarySearchText || null"
          [secondarySearchText]="librarySearch && librarySearch.secondarySearchText || null"
          [selectAllActive]="librarySearch && librarySearch.selectAllActive || false"
          [selectedDocumentIds]="librarySearch && librarySearch.selectedDocumentIds || null"
          [deselectedDocumentIds]="librarySearch && librarySearch.deselectedDocumentIds || null"
          [totalRecordCount]="librarySearch && librarySearch.pagedData && librarySearch.pagedData.totalRecords || 0"
          (isBulkUserReplacementSliderActive)="closeBulkUserReplacementSlider($event)"
          (clearSelectionsRequested)="onClearSelectionsRequested()"
        ></app-document-bulk-user-replacement>
      </div>
    </div>
  </div>
</div>
<ng-template #screenNotAccessible>
  <app-error [errorMessage]="errorMessage"></app-error>
</ng-template>